import React from "react";
import PropTypes from "prop-types";
import { Row } from "components/Containers";
import { FormattedMessage } from "react-intl";
import Status from "components/Status";
import { useAuth } from "hooks";

/**
 * ApplicantNotificationStatus
 *
 * @param {Object} row
 */
const ApplicantNotificationStatus = ({ row }) => {
  const { isAdmin } = useAuth();
  const { required, sent } = row?.notification || {};

  if (!isAdmin || !required) return null;

  return (
    <Row gap="0.4rem" noWrap>
      <Status enabled={sent}>
        <FormattedMessage id={`Missions.Applicants.Notification.${sent ? "Notified" : "NotNotified"}`} />
      </Status>
    </Row>
  );
};

ApplicantNotificationStatus.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string,
    notification: PropTypes.shape({
      required: PropTypes.bool,
      sent: PropTypes.bool,
      sentAt: PropTypes.string,
    }),
  }).isRequired,
};

export default ApplicantNotificationStatus;
